import * as $ from 'jquery';
import 'bootstrap';
// import 'selectiize';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from '../c005-bookingform-common';
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
import { max, min } from 'moment';
require('parsley');


export class onlineServicesBuy {
    private proceedPayment: any = $('#payment-proceed');
    $scope: any = $('#online-services--buy-points');
    private $loginError: Array<string> = [];
    private formEl: any = $('#online-services--buy-points');
    private memberBase: any = new memberPortal(); $error: Array<any>;
    private enrichBuyData: any = null;
    private bookingformcommon = new bookingFormCommon();
    private statecodes: any = [];


    /**
     * Initialize all points inputs with focus and filled effects
     * @return {any} [description]
     */
    initTextInputs(): any {
        let _self = this;
        let inputElArr: any = _self.formEl.find('input[type="text"]');

        _self.memberBase.initFormTextInputs(inputElArr);
    }
    enrichBuyPointsCheck(): any {
        let defer = $.Deferred();
        if (window.location.hostname == "localhost" && window.location.port == '5000') {
            let buyPointsUrl = '/dummy-data/buyPoints.json';
            if (buyPointsUrl) {
                $.get(buyPointsUrl)
                    .done((data: any) => {
                        console.log(data);
                        if (typeof data === 'string') {
                            this.enrichBuyData = JSON.parse(data);
                        } else {
                            this.enrichBuyData = data;
                        }
                        this.processUIBuyData();
                        defer.resolve();
                    }).fail((error: any) => {
                        defer.reject(error);
                    });
            }
        } else {
            var data = {
                'purchaseType': "buy_points"
            }
            let _self = this;
            $.ajax({
                type: 'GET',
                url: '/bin/services/new/getBuyTierPurchasePoints',
                data: data,
                success: function (dataParse: any) {
                    _self.enrichBuyData = dataParse
                    _self.processUIBuyData();
                    defer.resolve();
                }, error: function (error: any) {
                    defer.reject(error);
                }
            });
        }
        return defer.promise();
    }
    validateForm(): any {
        let _self = this;
        let proceedPayment: any = $('#payment-proceed');
        $('#online-services-buy-desktop-one').on("click keyup", function () {
            let textValue = $(this).val();
            $('#online-services--buy-amount-one').text(textValue);
            var textValueone = $('#my-order-points-buy-value-one');
            if (textValue != null && textValue != '' && textValue != undefined) {
                var textValueFirst = parseInt($(this).val()) * _self.enrichBuyData[0].monetaryAmount;
                // var totalValue = bigDecimal.round(textValueFirst, 2, bigDecimal.RoundingModes.CEILING);
                var totalValue = textValueFirst.toFixed(2);
                if ((parseInt($(this).val()) < parseInt(_self.enrichBuyData[0].minimumAmount)) || (parseInt($(this).val()) > parseInt(_self.enrichBuyData[0].maximumAmount))) {
                    textValueone.html('0.00');
                } else {
                    textValueone.text(totalValue);
                }
            } else {
                textValueone.html('0.00');
            }
        });

        $(' #online-services-buy-desktop-two').on("click keyup", function () {
            let textValue = $(this).val();
            $('#online-services--buy-amount-two').text(textValue);
            var textValueTwo = $('#my-order-points-buy-value-two');
            if (textValue != null && textValue != '' && textValue != undefined) {
                let textValueSecond = parseInt($(this).val()) * _self.enrichBuyData[1].monetaryAmount;
                // var totalValue = bigDecimal.round(textValueSecond, 2, bigDecimal.RoundingModes.CEILING);
                var totalValue = textValueSecond.toFixed(2);
                if ((parseInt($(this).val()) < parseInt(_self.enrichBuyData[1].minimumAmount)) || parseInt($(this).val()) > parseInt(_self.enrichBuyData[1].maximumAmount)) {
                    textValueTwo.html('0.00');
                } else {
                    textValueTwo.text(totalValue);
                }
            } else {
                textValueTwo.html('0.00');
            }
        });
        $('#online-services-buy-desktop-three').on("click keyup", function () {
            let textValue = $(this).val();
            $('#online-services--buy-amount-three').text(textValue);
            var textValueThree = $('#my-order-points-buy-value-three');
            if (textValue != null && textValue != '' && textValue != undefined) {
                let textValueThird = parseInt($(this).val()) * _self.enrichBuyData[2].monetaryAmount;
                //   var totalValue = bigDecimal.round(textValueThird, 2, bigDecimal.RoundingModes.CEILING);
                var totalValue = textValueThird.toFixed(2);
                if ((parseInt($(this).val()) < parseInt(_self.enrichBuyData[2].minimumAmount)) || parseInt($(this).val()) > parseInt(_self.enrichBuyData[2].maximumAmount)) {
                    textValueThree.html('0.00');
                } else {
                    textValueThree.text(totalValue);
                }
            } else {
                textValueThree.html('0.00');
            }
        });
        $('#online-services-buy-desktop-four').on("click keyup", function () {
            let textValue = $(this).val();
            $('#online-services--buy-amount-four').text(textValue);
            var textValueFour = $('#my-order-points-buy-value-four');
            if (textValue != null && textValue != '' && textValue != undefined) {
                let textValueFourth = parseInt($(this).val()) * _self.enrichBuyData[3].monetaryAmount;
                //var totalValue = bigDecimal.round(textValueFourth, 2, bigDecimal.RoundingModes.CEILING);
                var totalValue = textValueFourth.toFixed(2);
                if ((parseInt($(this).val()) < parseInt(_self.enrichBuyData[3].minimumAmount)) || parseInt($(this).val()) > parseInt(_self.enrichBuyData[3].maximumAmount)) {
                    textValueFour.html('0.00');
                } else {
                    textValueFour.text(totalValue);
                }
            } else {
                textValueFour.html('0.00');
            }
        });
        $('#online-services-buy-desktop-max').on("click keyup", function () {
            let textValue = $(this).val();
            $('#online-services--buy-amount-max').text(textValue);
            var textValueMax = $('#my-order-points-buy-value-max');
            if (textValue != null && textValue != '' && textValue != undefined) {
                let textValueLast = parseInt($(this).val()) * _self.enrichBuyData[4].monetaryAmount;
                // var totalValue = bigDecimal.round(textValueLast, 2, bigDecimal.RoundingModes.CEILING);
                var totalValue = textValueLast.toFixed(2);
                if (parseInt($(this).val()) < parseInt(_self.enrichBuyData[4].minimumAmount)) {
                    textValueMax.html('0.00');

                } else {
                    textValueMax.text(totalValue);
                }
            } else {
                textValueMax.html('0.00');
            }
        });
        //Desktop & Mobile value total value
        let totalValuesDesktop = $('#online-services-buy-desktop-max,#online-services-buy-desktop-four, #online-services-buy-desktop-three, #online-services-buy-desktop-two ,#online-services-buy-desktop-one, #terms-checkbox');
        totalValuesDesktop.on("click keyup", function (e: any) {
            let rangeOne = $('#online-services-buy-desktop-one');
            let rangeTwo = $('#online-services-buy-desktop-two');
            let rangeThree = $('#online-services-buy-desktop-three');
            let rangeFour = $('#online-services-buy-desktop-four');
            let rangeMax = $('#online-services-buy-desktop-max');
            let check = $('#terms-checkbox');
            let $screenSize: any = $(window).width();

            if (((Number(rangeOne.val())) >= (Number(_self.enrichBuyData[0].minimumAmount))) && ((Number(rangeOne.val())) <= (Number(_self.enrichBuyData[0].maximumAmount)))) {
                $('.online-services-buy-desktop-one').css('color', '#29c5c5');
                $('.online-services-buy-desktop-one').css('border-color', '#29c5c5');
            } else {
                $('.online-services-buy-desktop-one').css('color', '#f00');
                $('.online-services-buy-desktop-one').css('color', '#f00');
            }
            if (((Number(rangeTwo.val())) >= (Number(_self.enrichBuyData[1].minimumAmount))) && ((Number(rangeTwo.val())) <= (Number(_self.enrichBuyData[1].maximumAmount)))) {
                $('.online-services-buy-desktop-two').css('color', '#000');
            } else {
                $('.online-services-buy-desktop-two').css('color', '#f00');
            }
            if (((Number(rangeThree.val())) >= (Number(_self.enrichBuyData[2].minimumAmount))) && ((Number(rangeThree.val())) <= (Number(_self.enrichBuyData[2].maximumAmount)))) {
                $('.online-services-buy-desktop-three').css('color', '#29c5c5');
            } else {
                $('.online-services-buy-desktop-three').css('color', '#f00');
            }
            if (((Number(rangeFour.val())) >= (Number(_self.enrichBuyData[3].minimumAmount))) && ((Number(rangeFour.val())) <= (Number(_self.enrichBuyData[3].maximumAmount)))) {
                $('.online-services-buy-desktop-four').css('color', '#29c5c5');
            } else {
                $('.online-services-buy-desktop-four').css('color', '#f00');
            }
            if ((Number(rangeMax.val())) >= (Number(_self.enrichBuyData[4].minimumAmount))) {
                $('#online-services-buy-desktop-max').css('color', '#29c5c5');
            } else {
                $('#online-services-buy-desktop-max').css('color', '#f00');
            }
            if (((rangeOne.val() == '') || (((Number(rangeOne.val())) >= (Number(_self.enrichBuyData[0].minimumAmount))) && ((Number(rangeOne.val())) <= (Number(_self.enrichBuyData[0].maximumAmount))))) && ((rangeTwo.val() == '') || (((Number(rangeTwo.val())) >= (Number(_self.enrichBuyData[1].minimumAmount))) && ((Number(rangeTwo.val())) <= (Number(_self.enrichBuyData[1].maximumAmount))))) && ((rangeThree.val() == '') || (((Number(rangeThree.val())) >= (Number(_self.enrichBuyData[2].minimumAmount))) && ((Number(rangeThree.val())) <= (Number(_self.enrichBuyData[2].maximumAmount))))) && ((rangeFour.val() == '') || (((Number(rangeFour.val())) >= (Number(_self.enrichBuyData[3].minimumAmount))) && ((Number(rangeFour.val())) <= (Number(_self.enrichBuyData[3].maximumAmount))))) && ((rangeMax.val() == '') || ((Number(rangeMax.val())) >= (Number(_self.enrichBuyData[4].minimumAmount)))) && ((rangeOne.val() != '') || (rangeTwo.val() != '') || (rangeThree.val() != '') || (rangeFour.val() != '') || (rangeMax.val() != '')) && (check.is(':checked'))) {
                $('#payment-proceed').css('opacity', '1');
                $('#payment-proceed').css('background-color', '#005aaa');
                $('#payment-proceed').css('pointer-events', 'auto');
            } else {
                $('#payment-proceed').css('opacity', '0.5');
                $('#payment-proceed').css('background-color', '#808080');
                $('#payment-proceed').css('pointer-events', 'none');
            }

            let total = parseFloat($('#my-order-points-buy-value-one').text()) + parseFloat($('#my-order-points-buy-value-two').text()) + parseFloat($('#my-order-points-buy-value-three').text()) + parseFloat($('#my-order-points-buy-value-four').text()) + parseFloat($('#my-order-points-buy-value-max').text());
            $('#my-order-points-buy-total').text(total.toFixed(2));

        });

        let toggleDesktop = $('#online-services-buy-desktop-max,#online-services-buy-desktop-four, #online-services-buy-desktop-three, #online-services-buy-desktop-two ,#online-services-buy-desktop-one, #terms-checkbox');
        toggleDesktop.on("click keyup", function (e: any) {
            let rangeOne = $('#online-services-buy-desktop-one');
            let rangeTwo = $('#online-services-buy-desktop-two');
            let rangeThree = $('#online-services-buy-desktop-three');
            let rangeFour = $('#online-services-buy-desktop-four');
            let rangeMax = $('#online-services-buy-desktop-max');

            if (rangeOne.val() != 0 || rangeOne.val() != '') {
                $('#online-services-buy-desktop-two,#online-services-buy-desktop-max,#online-services-buy-desktop-four, #online-services-buy-desktop-three').attr('disabled', 'true');
                $('#online-services-buy-desktop-two,#online-services-buy-desktop-max,#online-services-buy-desktop-four, #online-services-buy-desktop-three').css('background-color', '#808080');
                $('#my-order-value-one').removeClass('hide');
            } else if (rangeTwo.val() != '') {
                $('#online-services-buy-desktop-one,#online-services-buy-desktop-max,#online-services-buy-desktop-four, #online-services-buy-desktop-three').attr('disabled', 'true');
                $('#online-services-buy-desktop-one,#online-services-buy-desktop-max,#online-services-buy-desktop-four, #online-services-buy-desktop-three').css('background-color', '#808080');
                $('#my-order-value-two').removeClass('hide');
            } else if (rangeThree.val() != '') {
                $('#online-services-buy-desktop-one,#online-services-buy-desktop-max,#online-services-buy-desktop-four, #online-services-buy-desktop-two').attr('disabled', 'true');
                $('#online-services-buy-desktop-one,#online-services-buy-desktop-max,#online-services-buy-desktop-four, #online-services-buy-desktop-two').css('background-color', '#808080');
                $('#my-order-value-three').removeClass('hide');
            } else if (rangeFour.val() != '') {
                $('#online-services-buy-desktop-one,#online-services-buy-desktop-max,#online-services-buy-desktop-two, #online-services-buy-desktop-three').attr('disabled', 'true');
                $('#online-services-buy-desktop-one,#online-services-buy-desktop-max,#online-services-buy-desktop-two, #online-services-buy-desktop-three').css('background-color', '#808080');
                $('#my-order-value-four').removeClass('hide');
            } else if ((rangeMax.val() != '')) {
                $('#online-services-buy-desktop-one,#online-services-buy-desktop-two,#online-services-buy-desktop-four, #online-services-buy-desktop-three').attr('disabled', 'true');
                $('#online-services-buy-desktop-one,#online-services-buy-desktop-two,#online-services-buy-desktop-four, #online-services-buy-desktop-three').css('background-color', '#808080');
                $('#my-order-value-max').removeClass('hide');
            } else {
                $('#online-services-buy-desktop-max,#online-services-buy-desktop-one,#online-services-buy-desktop-two,#online-services-buy-desktop-four, #online-services-buy-desktop-three').removeAttr('disabled');
                $('#online-services-buy-desktop-two,#online-services-buy-desktop-one,#online-services-buy-desktop-max,#online-services-buy-desktop-four, #online-services-buy-desktop-three').css('background-color', '#ffffff');
                $('#my-order-value-one,#my-order-value-two,#my-order-value-three,#my-order-value-four,#my-order-value-max').addClass('hide');
            }


        });
    }
    processUIBuyData(): any {
        let _self = this;
        let validityInMonthsOne = $('#online-services--buy-points--validity-one');
        let validityInMonthsTwo = $('#online-services--buy-points--validity-two');
        let validityInMonthsThree = $('#online-services--buy-points--validity-three');
        let validityInMonthsFour = $('#online-services--buy-points--validity-four');
        let validityInMonthsMax = $('#online-services--buy-points--validity-max');
        validityInMonthsOne.html(_self.enrichBuyData[0].expiryPeriod);
        console.log(_self.enrichBuyData);
        console.log(_self.enrichBuyData[1].expiryPeriod);
        validityInMonthsTwo.html(_self.enrichBuyData[1].expiryPeriod);
        validityInMonthsThree.html(_self.enrichBuyData[2].expiryPeriod);
        validityInMonthsFour.html(_self.enrichBuyData[3].expiryPeriod);
        validityInMonthsMax.html(_self.enrichBuyData[4].expiryPeriod);
        let ratePerEnrichPointsOne = $('#online-services--buy-points--enrich-rate-points-one');
        let ratePerEnrichPointsTwo = $('#online-services--buy-points--enrich-rate-points-two');
        let ratePerEnrichPointsThree = $('#online-services--buy-points--enrich-rate-points-three');
        let ratePerEnrichPointsFour = $('#online-services--buy-points--enrich-rate-points-four');
        let ratePerEnrichPointsMax = $('#online-services--buy-points--enrich-rate-points-max');
        ratePerEnrichPointsOne.html(_self.enrichBuyData[0].monetaryAmount);
        ratePerEnrichPointsTwo.html(_self.enrichBuyData[1].monetaryAmount);
        ratePerEnrichPointsThree.html(_self.enrichBuyData[2].monetaryAmount);
        ratePerEnrichPointsFour.html(_self.enrichBuyData[3].monetaryAmount);
        ratePerEnrichPointsMax.html(_self.enrichBuyData[4].monetaryAmount);
        let myOrderEnrichPointsOne = $(' #online-services--buy-rate-one');
        let myOrderEnrichPointsTwo = $(' #online-services--buy-rate-two');
        let myOrderEnrichPointsThree = $(' #online-services--buy-rate-three');
        let myOrderEnrichPointsFour = $(' #online-services--buy-rate-four');
        let myOrderEnrichPointsMax = $(' #online-services--buy-rate-max');
        myOrderEnrichPointsOne.html(' @' + '&nbsp' + 'MYR ' + _self.enrichBuyData[0].monetaryAmount + '&nbsp' + ' / Points');
        myOrderEnrichPointsTwo.html(' @' + '&nbsp' + 'MYR ' + _self.enrichBuyData[1].monetaryAmount + '&nbsp' + ' / Points');
        myOrderEnrichPointsThree.html(' @' + '&nbsp' + 'MYR ' + _self.enrichBuyData[2].monetaryAmount + '&nbsp' + ' / Points');
        myOrderEnrichPointsFour.html(' @' + '&nbsp' + 'MYR ' + _self.enrichBuyData[3].monetaryAmount + '&nbsp' + ' / Points');
        myOrderEnrichPointsMax.html(' @' + '&nbsp' + 'MYR ' + _self.enrichBuyData[4].monetaryAmount + '&nbsp' + ' / Points');
        let enrichGiftPointsOne = $(' #online-services--buy-points--enrich-points-one');
        let enrichGiftPointsTwo = $(' #online-services--buy-points--enrich-points-two');
        let enrichGiftPointsThree = $(' #online-services--buy-points--enrich-points-three');
        let enrichGiftPointsFour = $(' #online-services--buy-points--enrich-points-four');
        let enrichGiftPointsMax = $(' #online-services--buy-points--enrich-points-max');
        enrichGiftPointsOne.html(_self.enrichBuyData[0].description);
        enrichGiftPointsTwo.html(_self.enrichBuyData[1].description);
        enrichGiftPointsThree.html(_self.enrichBuyData[2].description);
        enrichGiftPointsFour.html(_self.enrichBuyData[3].description);
        enrichGiftPointsMax.html(_self.enrichBuyData[4].description);
        console.log(_self.enrichBuyData[0].description);
        let textboxValueOne = $('#online-services-buy-desktop-one');
        let textboxValueTwo = $(' #online-services-buy-desktop-two');
        let textboxValueThree = $('#online-services-buy-desktop-three');
        let textboxValueFour = $('#online-services-buy-desktop-four');
        let textboxValueMax = $('#online-services-buy-desktop-max');
        textboxValueOne.attr('min', (_self.enrichBuyData[0].minimumAmount));
        textboxValueTwo.attr('min', (_self.enrichBuyData[1].minimumAmount));
        textboxValueThree.attr('min', (_self.enrichBuyData[2].minimumAmount));
        textboxValueFour.attr('min', (_self.enrichBuyData[3].minimumAmount));
        textboxValueMax.attr('min', (_self.enrichBuyData[4].minimumAmount));
        textboxValueOne.attr('max', (_self.enrichBuyData[0].maximumAmount));
        textboxValueTwo.attr('max', (_self.enrichBuyData[1].maximumAmount));
        textboxValueThree.attr('max', (_self.enrichBuyData[2].maximumAmount));
        textboxValueFour.attr('max', (_self.enrichBuyData[3].maximumAmount));
    }
    pointsForm(): any {

        let _self = this;
        _self.$scope.find('#payment-proceed').click((evt: any) => {
            var nav = $('.onlineServiceGiftpoints');
            if (nav.length) {
                var contentNav = nav.offset().top;
            }
            $('html, body').animate({ scrollTop: '100px' });
        });
    }
    //Invoice pop-up functionality
    invoiceIssuancePopup(): any {
        $('input[name="invoice-flag"]').change(function () {
            let selectedInvocieFlag = $(this).val();
            // Show or hide specific fields based on the selected value
            if (selectedInvocieFlag === 'invoice-true') {
                $(".invoice-popup").show();
                //$('.selection-invoice-issuance-container').show();
                $('input[value="my"]').prop('checked', true);
                $('input[value="single"]').prop('checked', true);
                // $('#invoice-issuarce-form').show();
                $('#passport-group').hide();
                $('#SSM-group').hide();
                $(".invoice-popup").removeClass("hide");
            } else if (selectedInvocieFlag === 'invoice-false') {
                // $('#invoice-issuarce-form').hide();
                $('.selection-invoice-issuance-container').hide();
                $(".invoice-popup").addClass("hide");
            }
        });
        $('input[name="citizenship"]').change(function () {
            let selectedCitizen = $(this).val();
            // Show or hide specific fields based on the selected value
            if (selectedCitizen === 'my') {
                $('#invoice-issuarce-form').show();
                $('#passport-group').hide();
                $('#NRIC-group').show();
                $("#SST-group").hide();
                $('#SSM-group').hide();
                $('.error').remove();
            } else if (selectedCitizen === 'nonmalaysian') {
                $('#invoice-issuarce-form').show();
                $('#passport-group').show();
                $('#NRIC-group').hide();
                $("#SST-group").hide();
                $('#SSM-group').hide();
                $('.error').remove();


            }
        });
        $('input[name="Payer-Type"]').change(function () {
            let selectedPayer = $(this).val();
            // Show or hide specific fields based on the selected value
            if (selectedPayer === 'single') {
                $('#invoice-issuarce-form').show();
                $('#passport-group').hide();
                $('#NRIC-group').show();
                $("#SST-group").hide();
                $('#SSM-group').hide();
                $('.error').remove();
                $('.selection-nationality').show();
            } else if (selectedPayer === 'group') {
                $('#invoice-issuarce-form').show();
                $('#passport-group').hide();
                $('#NRIC-group').hide();
                $('#SSM-group').show();
                $("#SST-group").show();
                $('.error').remove();
                $('.selection-nationality').hide();
            }
        });
    }
    invoicePopupCheckbox(): void {
        let _self = this;
        var invoicePopup = $.Deferred();
        let authenticationUrl: string = '';
        let countryselect: any;
        $('.error').remove();
        $("#invoice-issuance-checkbox").click(function () {
            if (window.location.hostname === 'localhost' && window.location.port == "5000") {
                authenticationUrl = '/dummy-data/getMemberShipData.json';
            }
            else {
                authenticationUrl = '/bin/services/new/getMembershipLCPAPI';
            }
            var data = {
                'action': 'fetch'
            };
            $.ajax({
                type: 'POST',
                url: authenticationUrl,
                data: data,
                success: function (data: any) {
                    //_self.bookingformcommon.preloaderClose();
                    let json: any = null;
                    if (typeof data === 'string') {
                        json = JSON.parse(data);
                    } else {
                        json = data;
                    }
                    if (data) {
                        $("#invoice_issuarce_name").val(json.firstName);
                        $("#invoice_issuarce_number").val(json.mobileNumber);
                        $("#invoice_issuarce_email").val(json.email);
                        $("#invoice_issuarce_address").val(json.homeAddress1);
                        $("#invoice_issuarce_passport").val(json.passportNumber);
                        $("#invoice_issuarce_NRIC").val(json.nricnumber);
                        // $("#issuanceCountry").append('<option style="color:black;" value="' + "23" + '">'  +   json.homeCountry + '</option>')
                        $("#issuanceCountry").val(json.homeCountry);
                        // const countryVal = 
                        //const coutrysLength = $('select#issuanceCountry option').length;
                        //const totalCountrys = $("#issuanceCountry");
                        // for(i=0; i>)
                        // for (var i = 0; i < coutrysLength; i++) {
                        //     if ($('select#issuanceCountry option')[i].value == countryVal) {
                        //         $(_self).attr("selected","selected");
                        //     }
                        // }
                        $("#issuanceState").val(json.homeState);
                        $("#invoice_issuarce_city").val(json.homeCity);
                        $("#invoice_issuarce_postCode").val(json.homePostCode);

                        countryselect = $('#issuanceCountry');
                        const countrySelectedVal = $("#issuanceCountry").val();
                        let listItems: any[] = [];
                        if(countrySelectedVal){
                            let availableStates = $.grep(_self.statecodes.CountriesList, function (country: any, ind: any) {
                                return country.CountryCode == countryselect.val()

                            })
                            let sel = $('.issuance-state-drop select');
                            $('.error').remove();
                            if (availableStates[0]) {
                                availableStates = availableStates[0].StatesList
                                listItems = []
                                for (var i = 0; i < availableStates.length; i++) {
                                    listItems[i] += "<option value='" + availableStates[i].StateCode + "'>" + availableStates[i].StateName + "</option>";
                                }
                            } else {
                                listItems[0] += ('<option value="NULL">--</option>');
                                $('.issuance-state-drop select').after('<span class="error">No states availble for selected country</span>');
                            }
                            sel.empty();
                            sel.append(listItems);
                        }
                    }
                }, error: function (error: any) {
                    invoicePopup.reject(error)
                }
            });
        });
    };
    handleCountryStates(): any {
        let _self = this;
        let countryselect: any;
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        countryselect = $('#issuanceCountry');

        let listItems: any[] = [];
        countryselect.on("change", function () {
            let availableStates = $.grep(_self.statecodes.CountriesList, function (country: any, ind: any) {
                return country.CountryCode == countryselect.val()

            })
            let sel = $('.issuance-state-drop select');
            $('.error').remove();
            if (availableStates[0]) {
                availableStates = availableStates[0].StatesList
                listItems = []
                for (var i = 0; i < availableStates.length; i++) {
                    listItems[i] += "<option value='" + availableStates[i].StateCode + "'>" + availableStates[i].StateName + "</option>";
                }
            } else {
                listItems[0] += ('<option value="NULL">--</option>');
                $('.issuance-state-drop select').after('<span class="error">No states availble for selected country</span>');
            }
            sel.empty();
            sel.append(listItems);
        })
    }
    //Country and States Drop-Down Data Getting
    selectCountryData(): void {
        let _self = this;
        var countryInput = $('.issuance-country-drop select');

        var getCountryOptions = $.Deferred();
        let countrycodeurl: string = '';
        if (window.location.hostname === 'localhost' && window.location.port == "5000") {
            countrycodeurl = '/dummy-data/countrycode.json';
        }
        else {
            countrycodeurl = '/content/dam/mas/json/countrycode.json';
        }
        //countrycodeurl = '/content/dam/mas/json/countrycode.json';
        $.get(countrycodeurl)
            .done((data: any) => {
                var listItems = "<option value=''> </option>";
                if (window.location.hostname === 'localhost' && window.location.port == "5000") {
                    if (typeof data === 'string') {
                        data = JSON.parse(data);
                    }
                }
                for (var i = 0; i < data.Countries.length; i++) {
                    listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
                }
                getCountryOptions.resolve(listItems);
                $(countryInput).append(listItems);
            })
            .fail((error: any) => {
                getCountryOptions.reject(error);
            });

        // new country and state code 
        var stateCodeInput = $('.issuance-state-drop select');
        let newcountrycodeurl: string = '';
        if (window.location.hostname === 'localhost' && window.location.port == "5000") {
            newcountrycodeurl = '/dummy-data/updateState.json';
        }
        else {
            newcountrycodeurl = '/content/dam/mas/json/statecodes.json'
        }
        var getnewCountryOptions = $.Deferred();
        $.get(newcountrycodeurl)
            .done((data: any) => {
                var listItems = "<option value=''> </option>";
                if (window.location.hostname === 'localhost' && window.location.port == "5000") {
                    if (typeof data === 'string') {
                        data = JSON.parse(data);
                    }
                }
                //localStorage.setItem("lcp-search", JSON.stringify(data));		
                for (var i = 0; i < data.CountriesList.length; i++) {
                    listItems += "<option value='" + data.CountriesList[i].CountryCode + "'>" + data.CountriesList[i].CountryName + "</option>";
                }
                getnewCountryOptions.resolve(listItems);
                //$(stateCodeInput).append(listItems);
            })
            .fail((error: any) => {
                getnewCountryOptions.reject(error);
            });
        var stateCodeInput = $('.issuance-state-drop select');
        // var stateCodeInputmob = $('#update-profile--personal-statesmob');		
        var getStateCodeOptions = $.Deferred();
        let stateCodeUrl: string = '';
        $.get(newcountrycodeurl)
            .done((data: any) => {
                var listItems = "<option value=''> </option>";
                if (window.location.hostname === 'localhost') {
                    if (typeof data === 'string') {
                        data = JSON.parse(data);
                    }
                }
                _self.statecodes = data
                _self.handleCountryStates();
                //_self.handleCountryStatesmob();
                for (var i = 0; i < data.CountriesList.length; i++) {
                    for (var j = 0; j < data.CountriesList[i].StatesList.length; j++) {
                        if (data.CountriesList[i].StatesList[j].StateCode != 'NULL') {
                            listItems += "<option value='" + data.CountriesList[i].StatesList[j].StateCode + "'>" + data.CountriesList[i].StatesList[j].StateName + "</option>";
                        }
                    }
                }
                getStateCodeOptions.resolve(listItems);
                $(stateCodeInput).append(listItems);

            })
            .fail((error: any) => {
                getStateCodeOptions.reject(error);
            });
    }

    proceedCheckout(): any {
        let _self = this;
        let requestData = {
            conversionRate: 0,
            totalAmountPayable: 0,
            totalAmount: 0,
            totalDiscount: 0,
            totalTax: 0,
            otherFees: 0,
            serviceType: 0,
            recipientId: "null",
            partnerOwnerCode: "null",
            productName: "",
            onlinePurchaseType: "buy_points",
            erp_points: "null",
            buy_points_code: "null",
            addNewCodes: "null",
            payer_name: "null",
            payer_tin: "null",
            payer_email: "null",
            payer_phoneNo: "null",
            payer_nationality: "null",
            payer_addressLine: "null",
            payer_city: "null",
            payer_state: "null",
            payer_country: "null",
            payer_postalCode: "null",
            payer_nric: "null",
            payer_ssm: "null",
            payer_passport: "null",
            payer_invoice: "null",
            payer_type: "null"

        }
        $('#payment-proceed').click(function (hit: any) {
            hit.stopPropagation();
			hit.preventDefault();
            var displayScreen = 'desktop';
            let isValid = true;
            const invoice_name = $('#invoice_issuarce_name').val();
            const invoice_email = $('#invoice_issuarce_email').val();
            const invoice_passport = $('#invoice_issuarce_passport').val();
            const invoice_citizenship = $('input[name="citizenship"]:checked').val();
            const invoice_nric = $('#invoice_issuarce_NRIC').val();
            const invoice_ssm = $('#invoice_issuarce_SSM').val();
            const invoice_tin = $('#invoice_issuarce_tin').val();
            const invoice_mobile = $('#invoice_issuarce_number').val();
            const invoice_address = $('#invoice_issuarce_address').val();
            const invoice_country = $('#issuanceCountry').val();
            const invoice_city = $('#invoice_issuarce_city').val();
            const invoice_state = $('#issuanceState').val();
            const invoice_postalCode = $('#invoice_issuarce_postCode').val();
            const invoice_type = $("input[name='invoice-flag']:checked").val();
            const invoice_payer_type = $('input[name="Payer-Type"]:checked').val();
            $('.error').remove();
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            // Validate name
            if (invoice_name === '') {
                $('#invoice_issuarce_name').after('<span class="error">Name is required</span>');
                isValid = false;
            }
            // Validate email
            if (invoice_email === '') {
                $('#invoice_issuarce_email').after('<span class="error">Email is required</span>');
                isValid = false;
            } else if (!emailPattern.test(invoice_email)) {
                $('#invoice_issuarce_email').after('<span class="error">Invalid email format</span>');
                isValid = false;
            }
             // Validate adress
             if (invoice_address === '') {
                $('#invoice_issuarce_address').after('<span class="error">Address is required</span>');
                isValid = false;
            } 
            //validate Mobile No
            const mobilePattern = /^\d{7,15}$/;
            if (invoice_mobile === '') {
                $('#invoice_issuarce_number').after('<span class="error">mobile is required</span>');
                isValid = false;
            } else if (!mobilePattern.test(invoice_mobile)) {
                $('#invoice_issuarce_number').after('<span class="error">Invalid mobile format</span>');
                isValid = false;
            }
              // Validate Country
              if (invoice_country === null) {
                $('#issuanceCountry').after('<span class="error">Country is required</span>');
                isValid = false;
            } 
              // Validate State
              if (invoice_state === null) {
                $('#issuanceState').after('<span class="error">State is required</span>');
                isValid = false;
            } 
            // Validate City
            if (invoice_city === '') {
                $('#invoice_issuarce_city').after('<span class="error">City is required</span>');
                isValid = false;
            } 
             // Validate Postal Code
             if (invoice_postalCode === '') {
                $('#invoice_issuarce_postCode').after('<span class="error">Postcode is required</span>');
                isValid = false;
            } 
            //Validate NRIC or Passport number based on citizenship
            let selectedPayer = $('input[name="Payer-Type"]:checked').val();
            if (selectedPayer === 'single') {
                if (invoice_citizenship === 'my') {
                    //var regex = new RegExp("^[A-Z][0-9]{8}$");
                    if (invoice_nric === '') {
                        $('#invoice_issuarce_NRIC').after('<span class="error">NRIC is required for Malaysian citizens</span>');
                        isValid = false;
                    } else if (!/^\d{6}-\d{2}-\d{4}$/.test(invoice_nric)) {
                        $('#invoice_issuarce_NRIC').after('<span class="error">Invalid NRIC format (e.g., 123456-78-1234)</span>');
                        isValid = false;
                    }
                } else {
                    if (invoice_passport === '') {
                        $('#invoice_issuarce_passport').after('<span class="error">Passport number is required for non-Malaysian citizens</span>');
                        isValid = false;
                    } else if (/[^A-Z0-9]+/g.test(invoice_passport)) {
                        $('#invoice_issuarce_passport').after('<span class="error">Invalid passport number format</span>');
                        isValid = false;
                    }
                }
            }
            // Validate SSM
            if (selectedPayer !== 'single') {
                if (invoice_ssm === '') {
                    $('#invoice_issuarce_SSM').after('<span class="error">SSM is required</span>');
                    isValid = false;
                } else if (!/^[a-zA-Z0-9]+$/.test(invoice_ssm)){
                    $('#invoice_issuarce_SSM').after('<span class="error">Invalid SSM number format</span>');
                    isValid = false;
                }
            }
            // Validate tin
            const tinPattern = /^[a-zA-Z0-9]+$/;
            if (invoice_tin === '') {
                $('.tooltip-icon').after('<span class="error">TIN is required</span>');
                isValid = false;
            } else if (!tinPattern.test(invoice_tin)) {
                $('.tooltip-icon').after('<span class="error">Invalid TIN format</span>');
                isValid = false;
            }
            //Checkbox Validation
            let invoiceCheckbox = $("#check-group");
            let invoiceCheckedVal = $("input[name='invoice-flag']:checked").val();
            if(invoiceCheckedVal === 'invoice-true'){
                if ($('#invoice-checkbox').is(':checked')) {
                    isValid = true;
                } else {
                    $(invoiceCheckbox).after('<span class="error checkbox_invoice">Checkbox is required</span>');
                    isValid = false;
                }
            }
            // if (!isValid) {
            //     event.preventDefault(); // Prevent form submission if validation fails
            // }
            if ($(".disabled-mob").css('display') === 'none') {
                displayScreen = 'mobile';
            }
            requestData.totalAmountPayable = $("#my-order-points-buy-total").text();
            requestData.totalAmount = $("#my-order-points-buy-total").text();
            requestData.partnerOwnerCode = _self.enrichBuyData[0].partnerOwnerCode;
            requestData.productName = _self.enrichBuyData[0].productName;
            requestData.addNewCodes = $("#newCodeChkBx").val();
            let erp_points = 0;
            let dataArr = ['one', 'two', 'three', 'four', 'max'];
            requestData['items'] = [];
            //requestData['payerDetails'] = [];
            _self.enrichBuyData.map((item: any, index: any) => {
                var textValueonesample = $('#my-order-points-buy-value-' + dataArr[index]).text();
                var totalValue = bigDecimal.round(textValueonesample, 2, bigDecimal.RoundingModes.DOWN);
                if (totalValue.trim() != "0.00") {
                    requestData.buy_points_code = item.code;
                    requestData.conversionRate = item.monetaryAmount;
                    requestData['items'].push({
                        "productId": item.code,
                        "productName": item.description,
                        "sku": item.description,
                        "skuType": " ",
                        "quantity": $('#online-services-buy-' + displayScreen + '-' + dataArr[index]).val(),
                        "subTotal": totalValue,
                        "total": $('#my-order-points-buy-value-' + dataArr[index]).text(),
                        "unitPrice": $('#online-services--buy-points--enrich-rate-points-' + dataArr[index]).text()
                    });
                };
                erp_points += Number($('#online-services-buy-' + displayScreen + '-' + dataArr[index]).val());
            });
            requestData.payer_name = invoice_name;
            requestData.payer_tin = invoice_tin;
            requestData.payer_email = invoice_email;
            requestData.payer_phoneNo = invoice_mobile;
            requestData.payer_nationality = invoice_citizenship;
            requestData.payer_addressLine = invoice_address;
            requestData.payer_city = invoice_city;
            requestData.payer_state = invoice_state;
            requestData.payer_country = invoice_country;
            requestData.payer_postalCode = invoice_postalCode;
            requestData.payer_nric = invoice_nric;
            requestData.payer_ssm = invoice_ssm;
            requestData.payer_passport = invoice_passport;
            requestData.payer_invoice = invoice_type;
            requestData.payer_type = invoice_payer_type;
            console.log(requestData);
            requestData.erp_points = erp_points.toString();
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich - Point Services - Buy Enrich Points',
                'clickName': 'click:btn-click:point-services-buy-points-payment',
                'componentType': 'btn',
                'componentName': 'Payment Button',
                'componentID': '',
                'attributes': [
                    {
                        'key': 'point-services-buy-points-submit',
                        'value': requestData['items'][0].quantity + ':' + requestData['items'][0].unitPrice + ':myr' + requestData['items'][0].total
                    }
                ]
            });
            const errorLength = $(".error").length;
            let selectedInvocieFlag = $('input[name="invoice-flag"]:checked').val();
            if (selectedInvocieFlag === 'invoice-true') {
                if (errorLength === 0) {
                    requestData['items'] = JSON.stringify(requestData['items']);
                    _self.bookingformcommon.preloader();
                    $.ajax({
                        type: 'POST',
                        url: "/bin/services/new/paymentcheckoutFormGetPPID",
                        data: requestData,
                        success: function (data: any) {
                            _self.bookingformcommon.preloaderClose();
                            let json: any = null;
                            if (typeof data === 'string') {
                                json = JSON.parse(data);
                            } else {
                                json = data;
                            }
                            if (json.errorCode === "OK" && json.id !== undefined) {
                                const localData = {
                                    postRedirection: window.location.href,
                                    postRedirectionValue: $("#my-order-points-buy-total").text(),
                                }
                                let setItems = function () {
                                    localStorage.setItem('online-services-data', JSON.stringify(localData));
                                    if (localStorage.getItem('online-services-data') === null) {
                                        setItems();
                                    } else {
                                        let url = window.location.href.split('/');
                                        window.location.href = "https://" + window.location.hostname + "/" + url[3] + "/" + url[4] + "/enrich-portal/home/online-services/checkout.html?ppid=" + json.id;
                                    }
                                }
                                setItems();
                            } else {
                                if (json.errorMsg) {
                                    $('.payment-error').addClass('showclass');
                                    $('.payment-error').removeClass('hideclass');
                                    $('.payment-error').html(json.errorMsg);
                                } else {
                                    $('.payment-error').addClass('showclass');
                                    $('.payment-error').removeClass('hideclass');
                                    //$('.payment-error').html('Unable to proceed, please try again.');
                                }
                            }

                        }, error: function (error: any) {
                            _self.bookingformcommon.preloaderClose();
                            console.log(error);
                            $('.payment-error').addClass('showclass');
                            $('.payment-error').removeClass('hideclass');
                            //$('.payment-error').html = "Something went wrong. Please try again.";
                        }
                    });
                } else{
                    $('html, body').animate({
                        scrollTop: $('#popup-invoice-issuarce-form-anchor').offset().top
                    }, 1000);
            }
            } else {
                requestData['items'] = JSON.stringify(requestData['items']);
                _self.bookingformcommon.preloader();
                $.ajax({
                    type: 'POST',
                    url: "/bin/services/new/paymentcheckoutFormGetPPID",
                    data: requestData,
                    success: function (data: any) {
                        _self.bookingformcommon.preloaderClose();
                        let json: any = null;
                        if (typeof data === 'string') {
                            json = JSON.parse(data);
                        } else {
                            json = data;
                        }
                        if (json.errorCode === "OK" && json.id !== undefined) {
                            const localData = {
                                postRedirection: window.location.href,
                                postRedirectionValue: $("#my-order-points-buy-total").text(),
                            }
                            let setItems = function () {
                                localStorage.setItem('online-services-data', JSON.stringify(localData));
                                if (localStorage.getItem('online-services-data') === null) {
                                    setItems();
                                } else {
                                    let url = window.location.href.split('/');
                                    window.location.href = "https://" + window.location.hostname + "/" + url[3] + "/" + url[4] + "/enrich-portal/home/online-services/checkout.html?ppid=" + json.id;
                                }
                            }
                            setItems();
                        } else {
                            if (json.errorMsg) {
                                $('.payment-error').addClass('showclass');
                                $('.payment-error').removeClass('hideclass');
                                $('.payment-error').html(json.errorMsg);
                            } else {
                                $('.payment-error').addClass('showclass');
                                $('.payment-error').removeClass('hideclass');
                                //$('.payment-error').html('Unable to proceed, please try again.');
                            }
                        }

                    }, error: function (error: any) {
                        _self.bookingformcommon.preloaderClose();
                        console.log(error);
                        $('.payment-error').addClass('showclass');
                        $('.payment-error').removeClass('hideclass');
                        //$('.payment-error').html = "Something went wrong. Please try again.";
                    }
                });
            }
        })
    }
}
let scope: Element = document.querySelector('.onlineServiceBuypoints');
if (scope) {
    try {
        let pointsForm = new onlineServicesBuy();
        var adobeDataLayer = new adobeDataLayerWrapper();
        pointsForm.initTextInputs();
        pointsForm.validateForm();
        pointsForm.pointsForm();
        pointsForm.enrichBuyPointsCheck();
        pointsForm.invoiceIssuancePopup();
        pointsForm.selectCountryData();
        pointsForm.invoicePopupCheckbox();
        pointsForm.proceedCheckout();
        adobeDataLayer.push('pageLoaded', {
            'pageName': '',
            'pageType': 'Enrich - Point Services - Buy Enrich Points',
            'attributes': []
        });
    } catch (e) { console.error(e); }
}
